import angular from "angular";

import core from "./core";
import materialModule from "./material";
import componentsModule from "./components";
import pagesModule from "./pages";
import resourcesModule from "./resources";
import servicesModule from "./services";
import googleAnalyticsModule from "./services/googleAnalytics/googleAnalytics.module";
import filtersModule from "./filters";
import directivesModule from "./directives";
import isNil from "lodash/fp/isNil";
import * as SentryBrowser from "@sentry/browser";
import * as SentryIntegrations from "@sentry/integrations";

import "./app.scss";

SentryBrowser.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [new SentryIntegrations.Angular()],
  ignoreErrors: [/Possibly unhandled rejection: .*"status.*":\d{3}.*/],
});

// Inject Sentry in production only
const injectSentryModule = () => {
  if (process.env.NODE_ENV === "production" && !isNil(process.env.SENTRY_DSN)) {
    return angular.module("sentry", ["ngSentry"]);
  }
  return angular.module("sentry", []);
};

const sentryModule = injectSentryModule();

angular
  .module("app", [
    core.name,
    materialModule.name,
    componentsModule.name,
    pagesModule.name,
    servicesModule.name,
    resourcesModule.name,
    filtersModule.name,
    directivesModule.name,
    sentryModule.name,
    googleAnalyticsModule.name,
  ])
  .run([
    "$rootScope",
    "$location",
    "$window",
    "localStorageService",
    function ($rootScope, $location, $window, localStorageService) {
      $rootScope.$on("$viewContentLoaded", function () {
        const authData = localStorageService.get("authdata");
        const roles = authData && authData.roles;
        if (!$window.ga) {
          return;
        }
        $window.ga("send", "pageview", {
          page: $location.path(),
        });
        if (Array.isArray(roles)) {
          roles.forEach((role) => {
            $window.ga("send", {
              hitType: "event",
              eventCategory: `Role: ${role.name}`,
              eventAction: $location.path(),
              eventLabel: $location.path(),
            });
          });
        }
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/index.js